import { useCallback, useEffect, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { accountIntegrationTenantApiSecurityService } from '@/projects/admin/services/account-integration-tenant-api-security-service';
import { useNavigate, useParams } from 'react-router-dom';
import { ITenantApiSecurity } from '@/core/interfaces/admin/usestate-interfaces';
import { t } from 'i18next';
import {  Button as DXButton } from 'devextreme-react';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import clsx from 'clsx';
import { Required } from '@/core/helper/validation-rule-helper';
import FormWrapper from '@/core/wrappers/form-wrapper';

function TenantApiSecurityDefinition() {
    const formRef: any = useRef<Form>();
    const submitFormRef: any = useRef<HTMLFormElement>();
    const [tenantApiSecurity, setTenantApiSecurity] = useState<ITenantApiSecurity>({ id: '', tenantId: '', tenantName: '', timestampPrivateKey: '', requestBodyHashIsActive: false, timestampAllowedTimeDifferenceInSeconds: null, timestampIsActive: false });

    const [tab, setTab] = useState('Main')
    const params = useParams();
    const tenantApiSecurityId = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        if (tenantApiSecurityId && tenantApiSecurity.id == '') {
            (async function () {
                const getTenantApiSecurity = await accountIntegrationTenantApiSecurityService.getTenantApiSecurity(tenantApiSecurityId)
                const data = getTenantApiSecurity.data;
                setTenantApiSecurity({ id: data.id, tenantId: data.tenantId, tenantName: data.tenantName, timestampPrivateKey: data.timestampPrivateKey, requestBodyHashIsActive: data.requestBodyHashIsActive, timestampAllowedTimeDifferenceInSeconds: data.timestampAllowedTimeDifferenceInSeconds, timestampIsActive: data.timestampIsActive });

            })();
        }

    }, []);

    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                setTab('Main')
                const tenantApiSecurityForm = { ...formRef.current.props.formData };
                if (tenantApiSecurityId) {
                    await accountIntegrationTenantApiSecurityService.updateTenantApiSecurity(null, tenantApiSecurityForm)
                } else {
                    await accountIntegrationTenantApiSecurityService.createTenantApiSecurity(tenantApiSecurityForm);
                    navigate(`/admin/account-tenant-api-security-list`, {});
                }
                resolve();
            } catch (error) {
                reject(error);
            }

        })
    }, []);  

    const tenantIdEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'tenantId' },
        hint: t("tenantId_hint")
    };
    const navigateBack = async () => {
        navigate('/admin/account-tenant-api-security-list', {})
    }
    return (
        <>
            <div className='card-body col-xl-12'>
                <div className='d-flex justify-content-end'>
                    <div className='col-auto me-5'>
                        <DXButton
                            text={t('back')}
                            type='normal'
                            icon='back'
                            useSubmitBehavior={false}
                            onClick={navigateBack}
                        />
                    </div>
                    <div className='col-auto'>
                        <DXButton
                            text={t("save")}
                            type='default'
                            width={120}
                            onClick={() => {
                                if (formRef.current) {
                                    const validationResult = formRef.current.instance.validate();
                                    if (validationResult.isValid) {
                                        submitFormRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className='card card-custom m-5'>
                <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                        className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                        role='tablist'
                    >
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Main' })}
                                onClick={() => setTab('Main')}
                                role='tab'
                            >
                                {t("definition")}
                            </a>
                        </li>
                    </ul>
                </div>

                <div className='card-body'>
                    <div className='tab-content pt-3'>
                        <div className={clsx('tab-pane', { active: tab === 'Main' })}>
                            <FormWrapper
                                onSubmit={handleSubmit}
                                formRef={formRef}
                                submitFormRef={submitFormRef}
                                formData={tenantApiSecurity}
                                isAddBackBtn={false}
                                simpleItemGroups={[
                                    {
                                        useColCountByScreen: true,
                                        items: [
                                            {
                                                dataField: 'tenantId',
                                                editorType: 'dxTextBox',                                               
                                                label: t('tenant_id'),
                                                editorOptions: tenantIdEditorOptions,
                                                isRequired: true,
                                                requiredMessage: Required(t('tenant_id'))
                                            },
                                            {
                                                dataField: 'tenantName',
                                                editorType: 'dxTextBox',
                                                label: t('retailer'),
                                                isRequired: true,
                                                requiredMessage: Required(t('retailer'))
                                            },
                                            {
                                                dataField: 'timestampIsActive',
                                                editorType: 'dxSwitch',
                                                label: t('timestamp_is_active')
                                            },
                                            {
                                                dataField: 'requestBodyHashIsActive',
                                                editorType: 'dxSwitch',
                                                label: t('request_body_hash_is_active'),
                                            },
                                            {
                                                dataField: 'timestampPrivateKey',
                                                editorType: 'dxTextBox',
                                                label: t('timestamp_private_key'),
                                            },
                                            {
                                                dataField: 'timestampAllowedTimeDifferenceInSeconds',
                                                editorType: "dxNumberBox",
                                                label: t('timestamp_allowe_time_difference_in_seconds'),
                                            }
                                        ]
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TenantApiSecurityDefinition;